import { render, staticRenderFns } from "./provision.vue?vue&type=template&id=668d655a&scoped=true&"
import script from "./provision.vue?vue&type=script&lang=js&"
export * from "./provision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d655a",
  null
  
)

export default component.exports